import { render, staticRenderFns } from "./VideoSlideItem.vue?vue&type=template&id=1586a120&scoped=true&"
import script from "./VideoSlideItem.vue?vue&type=script&lang=js&"
export * from "./VideoSlideItem.vue?vue&type=script&lang=js&"
import style0 from "./VideoSlideItem.vue?vue&type=style&index=0&id=1586a120&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1586a120",
  null
  
)

export default component.exports